import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import css from './Reporting.css';
import { Spinner } from '../../../components/widgets';
import Header from './Header';
import CampaignData from './components/CampaignData';
import AudienceDistribution from './components/AudienceDistribution';
import NetworkTable from './components/NetworkTable';
import Uplifts from './components/Uplifts';
import Analysis from './components/Analysis';
import { trackMixpanelEvent } from '../../../utils/general';
import { MIX_PANEL_KEYS, TRACK_EVENT_PREFIX } from '../../consts';
import { useReportingData } from './hooks/useReportingData';

const Reporting = ({ onClose, testId, onDeleteClick, onEditClick, translate }) => {
    const { normalizedData, isEmpty, eventKind, isLoading, selectedEvent, handlers, dateRange } = useReportingData(
        testId,
        translate
    );

    useEffect(() => trackMixpanelEvent(TRACK_EVENT_PREFIX, MIX_PANEL_KEYS.REPORT_VISIT), []);

    if (isLoading) {
        return <Spinner show expanded />;
    }

    const isDuplicateNetworkSelected =
        normalizedData.testChannels.length > 1 &&
        normalizedData.testChannels.every(channel => channel.name === normalizedData.testChannels[0].name);

    return (
        <div className={css.containerPopup}>
            <div className={css.content}>
                <div className={css.pageContainer}>
                    {normalizedData && (
                        <>
                            <Header
                                selectedStartDate={dateRange.start}
                                selectedEndDate={dateRange.end}
                                testData={normalizedData}
                                selectedEvent={selectedEvent}
                                onDeleteClick={() => onDeleteClick(normalizedData)}
                                onEditClick={() => onEditClick(normalizedData)}
                                handleDateChange={handlers.updateDateRange}
                                handleEventChange={handlers.updateSelectedEvent}
                                onClose={onClose}
                            />
                            <div className={css.contentContainer}>
                                <Uplifts
                                    isDuplicateNetworkSelected={isDuplicateNetworkSelected}
                                    networkUplifts={normalizedData?.networkUplifts || []}
                                />
                                <div>
                                    <Analysis
                                        key={eventKind}
                                        isEmpty={isEmpty}
                                        chartData={normalizedData?.chartData || {}}
                                        selected={eventKind}
                                        onEventToggle={handlers.toggleEventUnique}
                                        testChannels={normalizedData?.testChannels || []}
                                    />
                                    <NetworkTable
                                        isDuplicateNetworkSelected={isDuplicateNetworkSelected}
                                        eventName={selectedEvent.value}
                                        isEmpty={isEmpty}
                                        tableData={normalizedData?.tableData || {}}
                                        testChannels={normalizedData?.testChannels || []}
                                    />
                                </div>
                                <div className={css.rowContainer}>
                                    <CampaignData />
                                    <AudienceDistribution
                                        testChannels={normalizedData?.testChannels || []}
                                        groupsSize={normalizedData?.groupsSize || {}}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

Reporting.propTypes = {
    onClose: PropTypes.func.isRequired,
    testId: PropTypes.number,
    translate: PropTypes.func,
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
};

export default withLocalize(Reporting);
